import React from 'react';

import { Typography } from '@/UIlibrary/Typography/Typography';
import { useTranslations } from 'use-intl';
import { toTranslationKey } from '@/utils/translations';
import { formatValue } from './utils';
import { Request } from '@/graphql/__generated__/van-credits';
import QuestionnaireInput from './QuestionnaireInput';
interface MonthlyNetIncomeProps {
	data: Request;
	title: string;
}

const MonthlyNetIncome: React.FC<MonthlyNetIncomeProps> = ({ data, title }) => {
	const t = useTranslations('VanCreditRequestQuestionnaire');

	return (
		<div className="flex flex-col gap-1 p-4 bg-white rounded-lg w-full">
			<div className={`flex flex-row items-center mb-4`}>
				<div className="grow">
					<Typography weight="semibold">{t(toTranslationKey(title))}</Typography>
				</div>
			</div>
			<div className="flex flex-row flex-wrap">
				<div className="w-1/2 px-3 py-1">
					<QuestionnaireInput
						title={'Income'}
						value={formatValue(data.monthlyIncomeInformation?.totalIncome, t)}
					/>
				</div>
				<div className="w-1/2 px-3 py-1">
					<QuestionnaireInput
						title={'BusinessExpenses'}
						value={`-${formatValue(data.monthlyBusinessExpenses?.totalBusinessExpenses, t)}`}
					/>
				</div>
				<div className="w-1/2 px-3 py-1">
					<QuestionnaireInput
						title={'CreditPayments'}
						value={`-${formatValue(data.otherCredits?.monthlyPaymentToCredits, t)}`}
					/>
				</div>
				<div className="w-1/2 px-3 py-1">
					<QuestionnaireInput
						title={'HouseExpenses'}
						value={`-${formatValue(data.monthlyHouseExpenses?.totalHouseExpenses, t)}`}
					/>
				</div>
				<div className="w-1/2 px-3 py-1"></div>
				<div className="w-1/2 px-3 py-1">
					<QuestionnaireInput
						title={'CalculatedMonthlyNetIncome'}
						value={formatValue(data.calculatedNetIncome, t)}
					/>
				</div>
			</div>
		</div>
	);
};
export default MonthlyNetIncome;
